<template>
	<v-app>
		<div id="container" style="overflow-y:hidden;">
			<v-container id="notFound" wrap>
				<v-layout row wrap justify-center>
					<v-flex s12 align-center>
						<v-card height="80vh">
							<v-card-title>
								<v-layout row wrap fill-height align-center>
									<v-flex xs2>
										<v-img :src="require('@/assets/img/0_Skolable.png')"></v-img>
									</v-flex>
								</v-layout>
							</v-card-title>
							<v-layout row wrap fill-height align-center>
								<v-flex xs6>
									<v-img :src="require('@/assets/onBoarding/SKLB-Registro.png')"></v-img>
								</v-flex>
								<v-flex xs6>
									<h1>La ruta especificada no se encuentra disponible o no existe.</h1>
									<h2>Código: 404</h2>
								</v-flex>
							</v-layout>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</div>
	</v-app>
</template>

<script>
	export default {};
</script>

<style>
</style>
